import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from 'components/Dialog';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { PermissionTypes } from 'features/permissions/types';
import { usePermissions } from 'features/permissions/usePermissions';

type SetupCancelledProps = {
  onClose: () => void;
};

const SetupCancelledModal = ({ onClose }: SetupCancelledProps) => {
  const { t } = useTranslation('room');

  const { hasPermissions } = usePermissions();
  const allowVideoBroadcast = hasPermissions(PermissionTypes.broadcastVideo);
  const allowAudioBroadcast = hasPermissions(PermissionTypes.broadcastAudio);

  const audioOnlyBroadcast = allowAudioBroadcast && !allowVideoBroadcast;

  return (
    <Dialog
      open
      maxWidth="xs"
      aria-labelledby="broadcast-setup-cancelled-title"
      aria-describedby="broadcast-setup-cancelled-description"
      onClose={onClose}
    >
      <DialogTitle id="broadcast-setup-cancelled-title" onClose={onClose}>
        {audioOnlyBroadcast
          ? t('broadcast_setup.cancel_audio_only.title')
          : t('broadcast_setup.cancel.title')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="broadcast-setup-cancelled-description">
          {audioOnlyBroadcast
            ? t('broadcast_setup.cancel_audio_only.description')
            : t('broadcast_setup.cancel.description')}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('broadcast_setup.cancel.btn_ok_label')}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default SetupCancelledModal;
